import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  Output,
  ViewChild,
  ViewEncapsulation,
} from '@angular/core';
import {
  FormBuilder,
  FormControl,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';

import { MatInputModule } from '@angular/material/input';

import { MatSelectModule } from '@angular/material/select';
import { MatButtonModule } from '@angular/material/button';

import { CommonModule, NgFor, NgIf } from '@angular/common';
import { pTicket } from '../../../interfaces/pTicket';

import {
  compareJSONValues,
  openSnackBar,
} from '../../../helpers/genericFunctions';
import { MatSnackBar } from '@angular/material/snack-bar';
import { PTicketService } from '../../../services/p-ticket.service';
import { PDescriptionService } from '../../../services/p-description.service';
import { MatRadioModule } from '@angular/material/radio';
import { MasterDataService } from '../../../services/master-data.service';
import {
  masterComponent,
  masterIssueType,
  masterSeverity,
  masterStatusGranulated,
  masterSupportLevel,
  masterTicketType,
} from '../../../interfaces/masterData';
import { globalUser } from '../../../helpers/globalFields';

@Component({
  selector: 'app-p-ticket-edit-ticket-data',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    MatButtonModule,
    MatInputModule,
    MatSelectModule,
    CommonModule,
    MatRadioModule,
  ],
  templateUrl: './p-ticket-edit-ticket-data.component.html',
  styleUrl: './p-ticket-edit-ticket-data.component.scss',
  encapsulation: ViewEncapsulation.None,
})
export class PTicketEditTicketDataComponent {
  ticketUpdatePermission: boolean = false;
  constructor(
    private formBuilder: FormBuilder,
    private snackBar: MatSnackBar,
    private pTicketService: PTicketService,
    private masterDataService: MasterDataService,
    private cdr: ChangeDetectorRef,
  ) {}
  // should be moved to be read from the database
  tickettypes!: masterTicketType[];
  supportlevels!: masterSupportLevel[];
  issuetypes!: masterIssueType[];
  severities!: masterSeverity[];
  components!: masterComponent[];
  statiGranulated!: masterStatusGranulated[];

  @Input() pTicket!: pTicket;
  @Input() canUpdate: boolean = false;
  @Output() pDescriptionAddedEmitter = new EventEmitter();

  message = {
    pTicketID: 1,
    pde_description: 'Info changed \n',
    pde_type: 'ChatBot',
  };

  editpTicketForm = this.formBuilder.group({
    pct_tickettype: new FormControl('', Validators.required),
    pct_supportlevel: new FormControl('', Validators.required),
    pct_issuetype: new FormControl('', Validators.required),
    pct_severity: new FormControl('', Validators.required),
    pct_component: new FormControl('', Validators.required),
    pct_status_granulated: new FormControl('', Validators.required),
    pct_system_version: new FormControl('', Validators.required),
  });
  fillForm() {
    this.editpTicketForm.patchValue({
      pct_supportlevel: this.pTicket.pct_supportlevel,
      pct_tickettype: this.pTicket.pct_tickettype,
      pct_issuetype: this.pTicket.pct_issuetype,
      pct_severity: this.pTicket.pct_severity,
      pct_component: this.pTicket.pct_component,
      pct_status_granulated: this.pTicket.pct_status_granulated,
      pct_system_version: this.pTicket.pct_system_version,
    });
  }

  ngOnInit() {
    //
    this.masterDataService.getMasterTicketTypeList().subscribe((response) => {
      this.tickettypes = response;
    });
    this.masterDataService.getMasterSupportLevelList().subscribe((response) => {
      this.supportlevels = response;
    });
    this.masterDataService.getMasterIssueTypeList().subscribe((response) => {
      this.issuetypes = response;
    });
    this.masterDataService.getMasterSeverityList().subscribe((response) => {
      this.severities = response;
    });
    this.masterDataService.getMasterComponentList().subscribe((response) => {
      this.components = response;
    });
    this.masterDataService
      .getMasterStatusGranulatedList()
      .subscribe((response) => {
        this.statiGranulated = response;
      });
    this.fillForm();
    if (this.pTicket.pct_status === 'closed') {
      this.pTicketClose();
    } else {
      this.pTicketOpen();
    }
  }
  ngOnChanges(): void {
    console.log('changes');
    if (!this.pTicket) return;

    if (!this.canUpdate) {
      this.editpTicketForm.enable();
    } else {
      this.editpTicketForm.disable();
    }
  }
  ngAfterViewInit(): void {
    if (!this.canUpdate) {
      this.editpTicketForm.enable();
    } else {
      this.editpTicketForm.disable();
    }
  }

  pTicketClose() {
    this.editpTicketForm.get('pct_supportlevel')?.disable();
    this.editpTicketForm.get('pct_tickettype')?.disable();
    this.editpTicketForm.get('pct_issuetype')?.disable();
    this.editpTicketForm.get('pct_severity')?.disable();
    this.editpTicketForm.get('pct_component')?.disable();
    this.editpTicketForm.get('pct_status_granulated')?.disable();
    this.editpTicketForm.get('pct_system_version')?.disable();
  }

  pTicketOpen() {
    this.editpTicketForm.get('pct_supportlevel')?.enable();
    this.editpTicketForm.get('pct_tickettype')?.enable();
    this.editpTicketForm.get('pct_issuetype')?.enable();
    this.editpTicketForm.get('pct_severity')?.enable();
    this.editpTicketForm.get('pct_component')?.enable();
    this.editpTicketForm.get('pct_status_granulated')?.enable();
    this.editpTicketForm.get('pct_system_version')?.enable();
  }

  /**
   * gets called on if this form needs to change pTicket data
   */
  onTicketDataUpdate(): void {
    // setup messaging
    let success_message = 'Ticket data successfully updated ';
    let error_message = 'Error while updating ticket data ';
    // find differences that should be logged into the ticket
    let differences = [];
    differences = compareJSONValues(this.pTicket, this.editpTicketForm.value);
    if (differences.length == 0) {
      openSnackBar('Nothing to change', 2000, this.snackBar);
      this.pDescriptionAddedEmitter.emit();
    } else {
      // create the logging description and update the ticket
      this.pTicketService
        .updatePTicket(
          this.pTicket.id,
          this.editpTicketForm.value,
          differences,
          success_message,
          error_message,
        )
        .subscribe(() => {
          this.pTicketService
            .getTicket(this.pTicket.id)
            .subscribe((pTicket) => {
              this.pTicket = pTicket;
              this.pDescriptionAddedEmitter.emit();
            });
        });
    }
  }
}
